import { request, withQuery } from './client';
import type { CashMoveInput, CloseShiftInput, OpenShiftInput, RegisterRef, ShiftSummary } from '@kassa/shared';

export const shiftsApi = {
  shiftRegisters: () => request<RegisterRef[]>('GET', '/api/shifts/registers'),
  // Açıq növbə yoxdursa API null qaytarır (boş gövdə); request boş gövdəni {} edir — onda da null.
  shiftCurrent: async (registerId: string): Promise<ShiftSummary | null> => {
    const r = await request<ShiftSummary | null>('GET', withQuery('/api/shifts/current', { registerId }));
    return r && typeof r === 'object' && 'shiftId' in r ? r : null;
  },
  shiftOpen: (body: OpenShiftInput) => request<ShiftSummary>('POST', '/api/shifts', body),
  shiftCash: (id: string, body: CashMoveInput) =>
    request<{ id: string }>('POST', `/api/shifts/${encodeURIComponent(id)}/cash`, body),
  shiftX: (id: string) => request<ShiftSummary>('GET', `/api/shifts/${encodeURIComponent(id)}/x`),
  shiftClose: (id: string, body: CloseShiftInput) =>
    request<ShiftSummary>('POST', `/api/shifts/${encodeURIComponent(id)}/close`, body),
};
